"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "createTargetGraph", {
    enumerable: true,
    get: function() {
        return createTargetGraph;
    }
});
const _targetgraph = require("@lage-run/target-graph");
const _workspacetools = require("workspace-tools");
const _getFilteredPackages = require("../../filter/getFilteredPackages.js");
const _hasRepoChanged = require("../../filter/hasRepoChanged.js");
function getChangedFiles(since, cwd) {
    const targetBranch = since || (0, _workspacetools.getDefaultRemoteBranch)({
        cwd
    });
    const changes = [
        ...new Set([
            ...(0, _workspacetools.getUntrackedChanges)(cwd) || [],
            ...(0, _workspacetools.getUnstagedChanges)(cwd) || [],
            ...(0, _workspacetools.getBranchChanges)(targetBranch, cwd) || [],
            ...(0, _workspacetools.getStagedChanges)(cwd) || []
        ])
    ];
    return changes;
}
async function createTargetGraph(options) {
    const { logger, root, dependencies, dependents, enableTargetConfigMerging, since, scope, repoWideChanges, ignore, pipeline, outputs, tasks, packageInfos, priorities } = options;
    const builder = new _targetgraph.WorkspaceTargetGraphBuilder(root, packageInfos, enableTargetConfigMerging);
    const packages = (0, _getFilteredPackages.getFilteredPackages)({
        root,
        logger,
        packageInfos,
        includeDependencies: dependencies,
        includeDependents: dependents,
        since,
        scope,
        repoWideChanges,
        sinceIgnoreGlobs: ignore
    });
    let changedFiles = [];
    // TODO: enhancement would be for workspace-tools to implement a "getChangedPackageFromChangedFiles()" type function
    // TODO: optimize this so that we don't double up the work to determine if repo has changed
    if (since) {
        if (!(0, _hasRepoChanged.hasRepoChanged)(since, root, repoWideChanges, logger)) {
            changedFiles = getChangedFiles(since, root);
        }
    }
    const pipelineEntries = Object.entries(pipeline);
    // Add lage pipeline configuration in the package.json files.
    // They are configured in the lage field, but without the package id.
    // i.e. having this package.json
    //    { "name": "@lage-run/globby", "lage": { "transpile": { type: "npmScript" } }}
    // is equivalent to having the following in lage.config.js
    // { pipeline: { "@lage-run/globby#transpile": { type: "npmScript" } }
    // We conciously add these 'after' the ones in lage.config.js
    // to indicate that the more specific package.json definition takes
    //  precedence over the global lage.config.js.
    for (const [packageId, packageInfo] of Object.entries(packageInfos)){
        const packageLageDefinition = packageInfo.lage;
        if (packageLageDefinition) {
            for (const [id, definition] of Object.entries(packageLageDefinition)){
                pipelineEntries.push([
                    packageId + "#" + id,
                    definition
                ]);
            }
        }
    }
    for (const [id, definition] of pipelineEntries){
        if (Array.isArray(definition)) {
            builder.addTargetConfig(id, {
                cache: true,
                dependsOn: definition,
                options: {},
                outputs
            }, changedFiles);
        } else {
            builder.addTargetConfig(id, definition, changedFiles);
        }
    }
    return await builder.build(tasks, packages, priorities);
}
